/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Stack,
  Autocomplete,
  TextField,
  // InputAdornment,
  IconButton,
  RadioGroup,
  // FormLabel,
  FormControlLabel,
  Radio,
} from "@common-ui/ui";
// import { orderBy } from "lodash";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  ArrowBack,
  Search,
  // Clear
} from "@mui/icons-material";
import { Divider, FormControl, Typography } from "@mui/material";
import { useDispatch } from "react-redux";

import { ClientList } from "./ClientList";
import { SelectionView } from "./SelectionView";

import { clearPlaces, clearCustomerAndPlaces } from "../../actions";

export const CreateAssetDialog = ({
  open,
  handleClose,
  handleCreate,
  // customer,
  clientData,
  name,
  setOpenCompleteAssetDialog,
  ...props
}) => {
  const [data, setData] = useState(clientData);
  const [searchQuery, setSearchQuery] = useState("");
  const [type, setType] = useState("ALL");
  const [selection, setSelection] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  let dispatch = useDispatch();
  // clean up on component unmount
  useEffect(() => {
    return () => {
      setData([]);
      setSearchQuery("");
      setType("ALL");
      setSelection(null);
      setIsLoaded(false);
    };
  }, []);

  useEffect(() => {
    setSelection(props.customer);
    props.setNewCustomer(props.customer);
  }, [props.customer]);

  useEffect(() => {
    setData(clientData);
    setIsLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientData]);

  useEffect(() => {
    if (String(searchQuery).trim() === "") return reset();
    const newData = data.filter((item) => {
      return (
        item?.name &&
        item?.name
          .toLowerCase()
          ?.trim()
          .indexOf(searchQuery && searchQuery.toLowerCase()?.trim()) > -1
      );
    });
    setData(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);
  // eslint-disable-next-line no-unused-vars

  const reset = () => {
    switch (type) {
      case "ALL":
        return setData(clientData);
      case "INTERNAL_CLIENTS":
        return setData(clientData?.filter((item) => item.id));
      case "EXTERNAL_CLIENTS":
        return setData(clientData?.filter((item) => item.system_id));
      default:
        return setData(clientData);
    }
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  // const handleSort = () => {
  //   setAsc(!asc);
  //   setData(orderBy(data, ["name"], [asc ? "asc" : "desc"]));
  // };
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="alert-dialog-name"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        fullWidth={true}
        // maxWidth="lg"
      >
        <>
          <DialogTitle sx={{ px: 2 }} id="alert-dialog-title" scroll="paper">
            <Stack sx={{ alignItems: "left" }}>
              {selection ? (
                <Typography fontSize={18} variant="h4">
                  Select the Asset Place
                </Typography>
              ) : (
                <Typography fontSize={18} variant="h4">
                  Select the Asset Owner
                </Typography>
              )}
            </Stack>
            {open ? (
              <IconButton
                aria-label="close"
                onClick={() => {
                  handleClose();
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>

          <DialogContent sx={{ px: 0 }}>
            <Box component="main">
              <Box sx={{ px: 2 }}>
                {selection ? (
                  ""
                ) : (
                  <Box sx={{ mb: 2 }}>
                    {/* Radio */}
                    <FormControl>
                      {/* <FormLabel id="select-CLIENTS-type">Select</FormLabel> */}
                      <RadioGroup
                        row
                        aria-labelledby="select-CLIENTS-type"
                        value={type}
                        onChange={(event, value) => {
                          setType(value);
                          console.log("Value", value);
                        }}
                        name="CLIENTS-type"
                      >
                        <FormControlLabel
                          value="ALL"
                          control={<Radio />}
                          label="All"
                        />
                        <FormControlLabel
                          value="INTERNAL_CLIENTS"
                          control={<Radio />}
                          label="Internal"
                        />
                        <FormControlLabel
                          value="EXTERNAL_CLIENTS"
                          control={<Radio />}
                          label="External"
                        />
                      </RadioGroup>
                    </FormControl>
                    {/* Search */}

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Autocomplete
                        id="name-select"
                        options={data.map((option) => option.name)}
                        sx={{ m: 0 }}
                        freeSolo
                        // limitTags={2}
                        autoComplete={false}
                        openOnFocus
                        // autoHighlight
                        size="small"
                        fullWidth
                        onChange={(event, value, reason) => {
                          if (reason === "clear") {
                            // console.log("Clear", data);
                            // return setData(data);
                            return reset();
                          }

                          setSearchQuery(value);
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        // disableClearable
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              value={searchQuery}
                              // label="Search Clients"
                              placeholder="Search Owners"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <Search />,
                                type: "search",
                                autoComplete: "new-password",
                              }}
                            />
                          );
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              {/* List View */}
              {/* {!isLoaded ? ( // Loading State for the List
                <Box
                  sx={{
                    mb: 2,
                    height: 464,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h5">Loading...</Typography>
                </Box>
              ) : (
                ""
              )} */}

              {!isLoaded ? (
                <Box
                  sx={{
                    mb: 2,
                    height: 400,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h5">Loading...</Typography>
                </Box>
              ) : isLoaded && !data.length ? (
                <Box
                  sx={{
                    mb: 2,
                    height: 400,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h5">No Results</Typography>
                </Box>
              ) : selection ? (
                <Box sx={{ mb: 2, height: 464 }}>
                  <SelectionView
                    dispatch={dispatch}
                    setPlaces={props.setPlaces}
                    places={props.places}
                    item={selection}
                    data={data}
                    setSelection={props.setCustomer}
                    placesParent={props.placesParent}
                    setPlacesParent={props.setPlacesParent}
                  />
                </Box>
              ) : (
                <ClientList
                  data={data}
                  setSelection={(item) => {
                    setSelection(item);
                    props.setNewCustomer(item);
                  }}
                />
              )}
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions
            sx={
              selection
                ? {
                    display: "flex",
                    justifyContent: "space-between",
                  }
                : {}
            }
          >
            {selection ? (
              <Box>
                <Button
                  color="primary"
                  // fullWidth
                  variant="outlined"
                  size="large"
                  startIcon={<ArrowBack />}
                  // disabled={customer && places.length ? false : true}
                  // type="submit"
                  onClick={() => {
                    dispatch(clearPlaces());
                    setSelection(null);
                    props.setPlaces([]);
                    props.setPlacesParent(undefined);
                    setSelection(null);
                  }}
                >
                  Change Owner
                </Button>
              </Box>
            ) : (
              ""
            )}
            <Box sx={{ display: "flex" }}>
              <div>
                <Button
                  sx={{ mr: 2 }}
                  color="primary"
                  variant="outlined"
                  // disabled={formik.isSubmitting}
                  // fullWidth
                  size="large"
                  // onClick={() => router.goBack()}
                  onClick={() => {
                    dispatch(clearCustomerAndPlaces());
                    props.setCustomer(null);
                    handleClose();
                  }}
                  // type="submit"
                >
                  Cancel
                </Button>{" "}
                {selection ? (
                  <Button
                    sx={{ mr: 2 }}
                    color="primary"
                    variant="contained"
                    // disabled={formik.isSubmitting}
                    // fullWidth
                    size="large"
                    // onClick={() => router.goBack()}
                    onClick={() => {
                      setOpenCompleteAssetDialog();
                      handleClose();
                    }}
                    // type="submit"
                  >
                    Done
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </Box>
          </DialogActions>
        </>
      </Dialog>
    </div>
  );
};
